export const FILTERS_LABEL = "Filtros";
export const DELETE_DIALOG_TITLE = "Excluir filtro salvo";
export const DELETE_CONFIRM_LABEL = "Confirmar exclusão";

/** Variante do tema: o gatilho small do mobile com o padding do botão normal (Figma 11466:5258). */
export const TRIGGER_MOBILE_CLASS = "p-button-sm-wide";
/** Campo (dropdown, multiselect, calendário) com o painel de opções aberto: o Esc é dele, não do painel de filtros. */
export const DROPDOWN_OPEN_SELECTOR = '[role="combobox"][aria-expanded="true"]';
export const PANEL_FLUSH_CLASS = "p-overlaypanel-flush";
